import { http } from '@/core/api/';

const apiUrl = 'api/pei/serviceneedquestionnaire';

export default {
  async getQuestions({ peiId, peiCodeId }) {
    const { data } = await http.get(
      `${apiUrl}/questions/${peiId}/${peiCodeId}`
    );

    return data || [];
  },
  async getAdditionalQuestions({ peiId, peiCodeId }) {
    const { data } = await http.get(
      `${apiUrl}/additionalquestions/${peiId}/${peiCodeId}`
    );

    return data || [];
  },
  async saveQuestions(payload) {
    const { data } = await http.post(`${apiUrl}/savequestions`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  },
};
